import { Formik } from "formik";
import { DisplayAddDesignMappingFormModal } from "./DisplayAddDesignMappingFormModal";
import {
  useAddDesignMappingFormSubmit,
  AddDesignMappingFormValueType,
} from "../../hooks/designMappings/useAddDesignMappingFormSubmit";
import { useNavigate } from "react-router-dom";

type AddDesignMappingFormModalProps = {
  isModalOpen: boolean;
  setModalOpen: (isModalOpen: boolean) => void;
};

export const AddDesignMappingFormModal: React.FC<
  AddDesignMappingFormModalProps
> = ({ isModalOpen, setModalOpen }) => {
  const navigate = useNavigate();
  const onSubmit = useAddDesignMappingFormSubmit((designMapping) => {
    navigate(`/design-mappings/${designMapping.id}`);
  });

  const initialValues: AddDesignMappingFormValueType = {
    name: "",
    service_type: "",
    format_id: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnBlur={false}
      validateOnChange={false}
    >
      <DisplayAddDesignMappingFormModal
        open={isModalOpen}
        onCancel={() => setModalOpen(false)}
      />
    </Formik>
  );
};
